import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import { TextField as MuiTextField, CircularProgress } from '@material-ui/core';
import Icon from '../Icon';

var TypeAhead = function TypeAhead(_ref) {
  var a11yLabel = _ref.a11yLabel,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      dsOnOpen = _ref.dsOnOpen,
      dsOnInputChange = _ref.dsOnInputChange,
      dsRenderOption = _ref.dsRenderOption,
      e2e = _ref.e2e,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      getOptionLabel = _ref.getOptionLabel,
      getOptionSelected = _ref.getOptionSelected,
      groupBy = _ref.groupBy,
      helperText = _ref.helperText,
      label = _ref.label,
      loading = _ref.loading,
      name = _ref.name,
      options = _ref.options,
      placeholder = _ref.placeholder,
      disableClearable = _ref.disableClearable,
      required = _ref.required,
      value = _ref.value;

  /* In the design system, all inputs are controlled.
   * Uncontrolled is when value === undefined. If presented
   * with an this invalid state, render nothing.
   */
  if (value === undefined || !options || !getOptionLabel) {
    return null;
  }

  return /*#__PURE__*/React.createElement(MuiAutocomplete, _extends({
    autoHighlight: true,
    autoSelect: true,
    "aria-label": a11yLabel
  }, e2e && {
    'data-e2e': e2e
  }, {
    disabled: disabled,
    fullWidth: fullWidth,
    getOptionLabel: getOptionLabel,
    getOptionSelected: getOptionSelected,
    groupBy: groupBy,
    loading: loading,
    noOptionsText: "No options",
    onChange: dsOnChange,
    onOpen: dsOnOpen,
    onInputChange: dsOnInputChange,
    options: options,
    renderOption: dsRenderOption,
    disableClearable: disableClearable,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(MuiTextField, _extends({}, params, {
        error: error,
        helperText: helperText
      }, e2e && {
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          'data-e2e': "".concat(e2e, "-input")
        })
      }, {
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: /*#__PURE__*/React.createElement(Icon, {
            body: "search"
          }),
          endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        }),
        name: name,
        placeholder: placeholder,
        required: required,
        label: label,
        variant: "outlined",
        size: "small"
      }));
    },
    size: "small",
    value: value
  }));
};

export default TypeAhead;

try {
  TypeAhead.__docgenInfo = {
    description: '',
    displayName: 'TypeAhead',
    methods: [],
    props: {
      a11yLabel: {
        defaultValue: null,
        description: 'ARIA label. Use if component if not accompanied by a visible label.',
        name: 'a11yLabel',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<{}>, value: any, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<any>) => void'
        }
      },
      dsOnOpen: {
        defaultValue: null,
        description: '',
        name: 'dsOnOpen',
        required: false,
        type: {
          name: '(event: ChangeEvent<{}>) => void'
        }
      },
      dsOnInputChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnInputChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<{}>, value: string, reason: AutocompleteInputChangeReason) => void'
        }
      },
      dsRenderOption: {
        defaultValue: null,
        description: '',
        name: 'dsRenderOption',
        required: false,
        type: {
          name: 'FC<{ option: { [key: string]: any; }; }>'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        required: true,
        type: {
          name: 'any'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the input will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      placeholder: {
        defaultValue: null,
        description: '',
        name: 'placeholder',
        required: false,
        type: {
          name: 'string'
        }
      },
      fullWidth: {
        defaultValue: null,
        description: 'If `true`, the input will take up the full width of its container.',
        name: 'fullWidth',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      loading: {
        defaultValue: null,
        description: 'If `true`, the component is in a loading state.',
        name: 'loading',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      getOptionLabel: {
        defaultValue: null,
        description: 'Used to determine the string value for a given option.\n' + "It's used to fill the input (and the list box options if `renderOption` is not provided).\n" + '@param option\n' + '@returns',
        name: 'getOptionLabel',
        required: false,
        type: {
          name: '(option: any) => string'
        }
      },
      getOptionSelected: {
        defaultValue: null,
        description: 'Used to determine if an option is selected, considering the current value.\n' + 'Uses strict equality by default.\n' + '@param option The option to test.\n' + '@param value The value to test against.\n' + '@returns',
        name: 'getOptionSelected',
        required: false,
        type: {
          name: '(option: any, value: any) => boolean'
        }
      },
      groupBy: {
        defaultValue: null,
        description: 'If provided, the options will be grouped under the returned string.\n' + 'The groupBy value is also used as the text for group headings when `renderGroup` is not provided.\n' + '@param options The options to group.\n' + '@returns',
        name: 'groupBy',
        required: false,
        type: {
          name: '(option: any) => string'
        }
      },
      options: {
        defaultValue: null,
        description: 'Array of options.',
        name: 'options',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      disableClearable: {
        defaultValue: null,
        description: "If `true`, the input can't be cleared.",
        name: 'disableClearable',
        required: false,
        type: {
          name: 'true'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label will be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label is displayed as required and the `input` element` will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      helperText: {
        defaultValue: null,
        description: 'The helper text content.',
        name: 'helperText',
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map